import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { api, TOKEN_KEY } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, res.data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Unable to sign in. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F5F2] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white border border-neutral-200 shadow-sm px-8 py-10">
        <Logo width={120} />
        <h1 className="mt-6 text-lg font-semibold text-neutral-900">Admin Console</h1>
        <p className="mt-1 text-sm text-neutral-500">Sign in to manage the HCC website.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div className="space-y-1.5">
            <Label htmlFor="admin-email" className="text-xs uppercase tracking-wider text-neutral-500">
              Email
            </Label>
            <Input
              id="admin-email"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="admin-password" className="text-xs uppercase tracking-wider text-neutral-500">
              Password
            </Label>
            <Input
              id="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-100 px-3 py-2">
              {error}
            </p>
          )}
          <Button type="submit" disabled={busy} className="w-full bg-[#4B0F1E] hover:bg-[#3a0c17]" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="mt-6 text-[11px] text-neutral-400">Restricted access. Authorised HCC personnel only.</p>
      </div>
    </div>
  );
}
